import { useAtom } from 'jotai';
import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { userPermissions } from 'store/public/userPermissions';

import { setUserPermissionsToLocal } from '../../../utils/js/userPermissions';

const useGetUserPermissions = () => {
  const [userPermissionsloading, setUserPermissionsLoading] = useState(false);

  const [, setUserPermissions] = useAtom(userPermissions);

  const { enqueueSnackbar } = useSnackbar();

  const getUserPermissions = () => {
    setUserPermissionsLoading(true);

    axiosClient
      .get('Account/GetAccessList')
      .then(res => {
        if (res.data && res.data.status === 200) {
          setUserPermissions({
            isReady: true,
            permissions: res.data.value,
          });
          setUserPermissionsToLocal(res.data.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setUserPermissionsLoading(false));
  };

  return { getUserPermissions, userPermissionsloading, userPermissions };
};

export { useGetUserPermissions };
